import type { AssetPanelContext } from './assetPanelContext'
import type { DrillDownTarget } from './operationalDrillDownContent'

export function assetPanelContextToDrillTarget(
  ctx: AssetPanelContext,
  primarySystemId?: string
): DrillDownTarget {
  const systemId = primarySystemId
  if (ctx.kind === 'vulnerability' && ctx.vulnerabilityId) {
    return { kind: 'vulnerability', id: ctx.vulnerabilityId, label: ctx.label, systemId }
  }
  if (ctx.kind === 'control' && ctx.controlLinkId) {
    return { kind: 'control', id: ctx.controlLinkId, label: ctx.label, systemId }
  }
  if (ctx.kind === 'risk' && ctx.sourceType && ctx.sourceId) {
    return {
      kind: 'risk',
      sourceType: ctx.sourceType,
      sourceId: ctx.sourceId,
      label: ctx.label,
      systemId,
    }
  }
  return null
}
